import { render } from "./CustomerDetail.vue?vue&type=template&id=302011ee&ts=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=ts"
export * from "./CustomerDetail.vue?vue&type=script&lang=ts"

import "./CustomerDetail.vue?vue&type=style&index=0&id=302011ee&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/CustomerDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "302011ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('302011ee', __exports__)) {
    console.log('reload')
    api.reload('302011ee', __exports__)
  }
  
  module.hot.accept("./CustomerDetail.vue?vue&type=template&id=302011ee&ts=true", () => {
    console.log('re-render')
    api.rerender('302011ee', render)
  })

}


export default __exports__